import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Card,
  CardContent,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Alert,
  CircularProgress,
} from "@mui/material";
// import { Link } from "react-router-dom";
import logo from '../../assets/nttlogoblanco1.png';

import { crudDoperationAPI } from "../../api/sqlExecutor";
import { evaluateAndReturn } from "../../Utils/common";

const SqlExecutor = () => {
  const [sql, setSql] = useState("");
  const [result, setResult] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleExecute = async () => {
    if (!sql.trim()) {
      setMessage("SQL cannot be empty.");
      return;
    }

    setLoading(true);
    setMessage("");
    setResult([]);

    try {
      const data = { sqlScript: sql };
      const response = await crudDoperationAPI(data);

      if (!response) {
        setMessage(response?.message || "Something went wrong.");
        setLoading(false);
        return;
      }

      let msg = response.message || "";
      if (response.RowsAffected !== undefined) {
        msg += ` Rows affected: ${response.RowsAffected}`;
      }

      setMessage(msg);
      
      setResult(response.data?.data || []);
    } catch (error) {
      setMessage("Error executing SQL query.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: "#fff", height: "100vh", overflow:"auto" }}>
      {/* AppBar Header */}
      <AppBar position="static" color="primary">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={logo}
              alt="Logo"
              style={{ height: 40, marginRight: 16 }}
            />
            <Typography variant="h6">  Cloud Management Platform </Typography>
          </div>
{/* 
          <div>
            <Button color="inherit" component={Link} to="/SqlExecutor">
              SQL Executor
            </Button>
            <Button color="inherit" component={Link} to="/s3Operation">
              S3 Operation
            </Button>
          </div> */}
        </Toolbar>
      </AppBar>

      {/* Page Header */}
      <div style={{ padding: "24px" }}>
        {/* <Typography variant="h4" gutterBottom>
          SQL Executor
        </Typography> */}

        {/* SQL Input Section */}
        <Card variant="outlined" sx={{ mb: 3 }}>
          <CardContent>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell width={150}>
                    <Typography>SQL Query:</Typography>
                  </TableCell>
                  <TableCell>
                    <TextField
                      fullWidth
                      variant="outlined"
                      value={sql}
                      onChange={(e) => setSql(e.target.value)}
                      placeholder="Enter your SQL query here..."
                    />
                  </TableCell>
                  <TableCell align="right">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleExecute}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                          Executing...
                        </>
                      ) : (
                        "Execute"
                      )}
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        {/* Message Alert */}
        {message && (
          <Alert severity="info" sx={{ mb: 3 }}>
            {message}
          </Alert>
        )}

        {/* Result Table */}
        {evaluateAndReturn(
          result && result.length > 0,
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 1 }}>
                Query Results:
              </Typography>
              <div style={{ width:"100%", overflowX:"auto" }}>
               
                  <Table size="small" sx={{ border: "1px solid #ddd" }}>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                        {Object.keys(result?.[0] || {}).map((key) => (
                          <TableCell key={key}>
                            <strong>{key}</strong>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {result.map((row, i) => (
                        <TableRow key={i}>
                          {Object.entries(row).map(([key, value]) => (
                            <TableCell key={key}>
                              {value !== null ? value.toString() : "NULL"}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
               
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};

export default SqlExecutor;
